export default __webpack_public_path__ + "static/media/login.c8a507cf.jpeg";